<template>
	<div class="notice_popup input change-asg">
		<div class="close">
			<img src="/images/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<div class="tit">참여소속사 변경</div>
		
		<div class="input_member">
			<tec-summary v-model="mberInfo" :tecMberSeq="data.tecMberSeq" />님의 참여소속사가 아래와 같이 변경됩니다.
		</div>
		<div class="change-box">
			<div class="change-row before">
				<p>변경 전</p><p class="corp">{{data.oldWorkingAsgNm}}</p>
			</div>
			<div class="change-row after">
				<p>변경 후</p>
				<AutoComplete class="corp-input" type="text" v-model="newWorkingAsgNm" :list="corpList" listText="corpNm" @autoComplete="setCorpInfo"  title="참여소속사" :rules="{'required':true}">
					<template v-slot:autoComplete="autoComplete">{{autoComplete.item.corpNm}} / {{autoComplete.item.bizRegNo}}</template>
				</AutoComplete>
			</div>
		</div>
		<div class="select-btn">
			<div class="btn" @click="$emit('close')">취소</div>
			<div class="btn" @click="save()">변경하기</div>
		</div>


	</div>
</template>

<script>
import tecSummary from "@/components/highpro/TecSummary.vue";

export default {
	props : {
		param : Object
	},
	data() {
		return {
			data : this.param,
			mberInfo : {},

			corpList : [],
			newWorkingAsgSeq : '', // 변경 후 참여소속사
			newWorkingAsgNm : '',
		}
	},

	components : {
		tecSummary
	},

	mounted() {
		this.corpSearch();
	},

	methods : {
		corpSearch() {
            var param = {
				order : 'asc'
            }
			this.$.httpPost('/api/prj/adm/getScoList', param)
				.then(res => {
					this.corpList = res.data;
				}).catch(this.$.httpErrorCommon);
		},

		setCorpInfo(corpInfo) {
			this.newWorkingAsgSeq = corpInfo.corpSeq;
			this.newWorkingAsgNm = corpInfo.corpNm;
		},

		save() {
			if(this.newWorkingAsgSeq == null || this.newWorkingAsgSeq == '') {
				alert("참여소속사를 선택하세요.");
				return false;
			}

			var param ={
				div: this.data.div, // app: 지원, inter: 인터뷰
				projectAppSeq :  this.data.projectAppSeq,
				interviewReqSeq :  this.data.interviewReqSeq,
				workingAsgSeq : this.newWorkingAsgSeq // 변경 후 참여소속사
			}

			this.$.httpPost('/api/prj/adm/updateWorkingAsgSeq', param)
				.then(() => {
					alert('참여소속사가 변경되었습니다.');
					this.$emit('close', true);
				}).catch(this.$.httpErrorCommon);

				
		}
	}

}
</script>